module.exports = __webpack_public_path__ + "static/media/logo.e29691a5.png";